import axiosInstance from "./axiosInstance";

export interface RoomTypeApi {
  publicId: string;
  code: string;
  roomName: string;
  description: string;
  isActive: boolean;
}

export interface RoomTypeListResponse {
  items: RoomTypeApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
}

export interface CreateRoomTypePayload {
  code: string;
  roomName: string;
  description: string; 
  isActive: boolean;
  createdBy: string;
}

export interface UpdateRoomTypePayload {
  publicId: string;
  code: string;
  roomName: string;
  description: string;
  isActive: boolean;
  updatedBy: string;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getRoomTypes = async (params: {
  searchText?: string | null;
  pageNo: number;
  pageSize: number;
}): Promise<RoomTypeListResponse> => {
  const res = await axiosInstance.get("/room-type/list", {
    headers: getAuthHeader(),
    params,
  });

  return res.data;
};

export const createRoomType = async (payload: CreateRoomTypePayload) => {
  const res = await axiosInstance.post("/room-type", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updateRoomType = async (payload: UpdateRoomTypePayload) => {
  const res = await axiosInstance.put("/room-type", payload, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const deleteRoomType = async (
  publicId: string,
  deletedBy: string
) => {
  const res = await axiosInstance.delete(
    `/room-type/${publicId}?deletedBy=${deletedBy}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};